import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import i18n from "i18next";
import "../vodafone.css"
import {Col, Row} from "reactstrap";
import {isBrowser} from "react-device-detect";

class Header extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        let classNames = "text-headline";
        classNames = isBrowser ? "text-headline-desktop" : classNames;

        if(this.props.showDesktopVersionSub){
            classNames = "text-headline-desktop-sub"
        }

        const headline = <div className={classNames}>{i18n.t(this.props.textResource, this.props)}</div>;

        return <Row>
            <Col xs={10} md={12}>
                {headline}
            </Col>
            <Col xs={2} />
        </Row>;
    }
}

export {Header}